import type { SwapProviderType, SwapReceiptFailReason } from "@opensea/graphql"

const SWAP_PROVIDER_NAMES: Record<SwapProviderType, string> = {
  LOCAL_BUY_NFT: "Buy",
  RELAY: "Relay",
  WETH: "WETH",
  BETH: "BETH",
  UNRECOGNIZED: "Unknown",
  LOCAL_MINT_NFT: "Mint",
  OPENSEA_UNI_V4_SWAP: "OpenSea",
}

export const getSwapProviderName = (swapProvider: SwapProviderType) => {
  return SWAP_PROVIDER_NAMES[swapProvider]
}

const SWAP_RECEIPT_FAIL_REASON_MESSAGES: Record<SwapReceiptFailReason, string> =
  {
    AMOUNT_TOO_LOW_TO_REFUND: "The swap amount is too low to refund.",
    DEPOSITED_AMOUNT_TOO_LOW_TO_FILL:
      "The deposited amount was too low to complete the swap.",
    DEPOSIT_ADDRESS_MISMATCH:
      "The deposit address does not match the address you're trying to swap from.",
    DEPOSIT_CHAIN_MISMATCH:
      "The deposit chain does not match the chain you're trying to swap from.",
    DOUBLE_SPEND: "The transaction was rejected due to a double spend attempt.",
    INCORRECT_DEPOSIT_CURRENCY:
      "The deposited currency does not match the expected currency.",
    SLIPPAGE: "Max slippage exceeded.",
    SOLVER_CAPACITY_EXCEEDED:
      "The solver's capacity has been exceeded. Please try again later.",
    ORIGIN_TRANSACTION_FAILED:
      "The origin transaction failed. Please try again.",
    UNKNOWN: "An unknown error occurred.",
    UNSPECIFIED: "An unspecified error occurred.",
  }

export const getSwapReceiptFailReasonMessage = (
  failReason: SwapReceiptFailReason,
) => {
  return SWAP_RECEIPT_FAIL_REASON_MESSAGES[failReason]
}
